import { compile } from 'path-to-regexp'
import { stringifyQuery } from '../utils'

export default function buildRoutes(routes) {
  return Object.keys(routes).reduce((named, name) => {
    const [path, component, props] = routes[name]
    const toPath = compile(path, { encode: encodeURIComponent })

    const route = ({ query, hash, ...params } = {}) => {
      const basePath = toPath(params)

      const queryString = query ? `?${stringifyQuery(query)}` : ''
      const hashString = hash ? `#${hash}` : ''

      return `${basePath}${queryString}${hashString}`
    }

    route.toString = () => path
    route.props = { name, path, component, ...props }

    return { ...named, [name]: route }
  }, {})
}
